import React from 'react';
import { Input } from '../ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Search } from 'lucide-react';

const AdminTableToolbar = ({
  search,
  onSearchChange,
  searchPlaceholder = 'Search...',
  filterValue,
  onFilterChange,
  filterOptions = [],
  filterPlaceholder = 'All statuses',
  total,
  loading,
}) => {
  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6 w-full justify-between">
      <div className="relative w-full max-w-md h-9">
        <Input
          placeholder={searchPlaceholder}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          className="!pl-9 h-full input-field w-full"
          disabled={loading}
        />
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground pointer-events-none" />
      </div>
      <div className="flex flex-wrap gap-2 sm:mr-5 max-w-md">
        {filterOptions.length > 0 && (
          <Select value={filterValue || 'all'} onValueChange={(v) => onFilterChange(v === 'all' ? '' : v)}>
            <SelectTrigger className="w-[140px] input-field">
              <SelectValue placeholder={filterPlaceholder} />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="all">{filterPlaceholder}</SelectItem>
              {filterOptions.map((opt) => (
                <SelectItem key={opt.value} value={opt.value}>
                  {opt.label}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
        )}
      </div>
    </div>
  );
};

export default AdminTableToolbar;
